/**
 * Fills `{{param}}` placeholders in a message template.
 *
 * One pass over the ORIGINAL string — a per-param `.replaceAll` on a growing
 * accumulator re-scans text a prior substitution just inserted, so a param
 * value that itself contains another param's `{{token}}` (e.g.
 * `{ a: '{{b}}', b: 'X' }`) would get wrongly re-substituted. The regex
 * callback reads straight from `params`, never from a mutated intermediate.
 * An unsupplied placeholder is left standing rather than blanked, so a gap in
 * the caller's params shows up in the rendered string instead of vanishing.
 */
export function interpolate(template: string, params?: Record<string, string | number>): string {
	if (!params) return template
	return template.replace(/\{\{(\w+)\}\}/g, (_match, key: string) =>
		key in params ? String(params[key]) : `{{${key}}}`,
	)
}
